import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { UserService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private router: Router,
    private userService: UserService,
  ) {}

  canActivate(): boolean | UrlTree {    
    return this.userService.isLoggedIn() || this.router.parseUrl('auth/login');
  }
}
